import { WhereFilterOp } from 'firebase/firestore';
import { Select } from 'shared/Components/Select';
import { Option } from 'shared/Components/Select/Select';
import styled from 'styled-components';

import DaterangePicker from './DaterangePicker';

const Row = styled.div`
  display: flex;
  width: 100%;
  flex-flow: row wrap;
`;

const FilterElem = styled.div`
  width: max-content;
  margin: 5px;
`;

interface FilterControleKeyProps {
  placeholder?: string;
  options: Option[];
  onChange?(item: any): void;
  onClear?(): void;
  name: string;
  operator?: WhereFilterOp;
  disabled?: boolean;
  type?: 'date-range' | 'select';
}

interface FilterControleProps {
  onChange?(item: any): void;
  keys?: FilterControleKeyProps[];
  values: any;
  clear?(name: string): void;
  loading?: boolean;
}

export default function FilterControle({
  onChange,
  keys,
  values,
  clear,
  loading,
}: FilterControleProps) {
  return (
    <Row>
      {keys &&
        keys?.map((key) => {
          return (
            <FilterElem key={`filter_option_${key?.name}`}>
              {!(key?.type || key?.type == 'select') && (
                <Select
                  isDisabled={(loading || key?.disabled) ?? false}
                  placeholder={key?.placeholder}
                  value={values[key?.name]}
                  options={[
                    { value: 'all', label: key?.placeholder ?? 'Any Item' },
                    ...key.options,
                  ]}
                  onChange={(item) => {
                    if (item?.value == 'all') {
                      if (key?.onClear) {
                        key?.onClear();
                        return;
                      }

                      if (clear) clear(key?.name);
                      return;
                    }

                    if (key?.onChange) {
                      key?.onChange({ ...item, name: key?.name });
                      return;
                    }

                    if (onChange) {
                      onChange({ ...item, name: key?.name });
                    }
                  }}
                />
              )}
              {key?.type == 'date-range' && (
                <DaterangePicker
                  label={key?.placeholder}
                  selectsRange={true}
                  isClearable={true}
                  inline={true}
                  selected={values[key?.name]?.startDate}
                  startDate={values[key?.name]?.startDate}
                  endDate={values[key?.name]?.endDate}
                  onChange={(item) => {
                    if (key?.onChange) {
                      key?.onChange({ ...item, name: key?.name });
                    }
                  }}
                  disabled={(loading || key?.disabled) ?? false}
                />
              )}
            </FilterElem>
          );
        })}
    </Row>
  );
}
